import { Link } from '@ta-interaktiv/contentbricks'
import { Key } from 'components/Chart_Key'
import { TextWidth } from 'components/Container'
import { Image } from 'components/Image'
import { Quote } from 'components/Quote'
import { ReactVideo } from 'components/ReactVideo'
import styled from 'styled-components'
const MapOverlayStyle = {
  backgroundColor: 'var(--site-background)',
  padding: 15,
  paddingTop: 40,
  paddingLeft: 30,
  paddingRight: 30,
  boxShadow:
    '0px 0px 9px 3px rgba(0,0,0,0.29), 0px 0px 5px 3px rgba(255,255,255,0.19)',
}

const FrontElement = styled.div<{
  transparent?: boolean
  centered?: boolean
  [x: string]: any
}>`
  pointer-events: all;

  width: 100%;
  background-color: var(--site-background);

  padding-top: 3em;
  padding-bottom: 3em;
  text-align: ${({ centered }) => (centered ? 'center' : 'left')};
  p {
    font-family: var(--font-serif);

    font-size: 18px;
    line-height: 30px;
  }
`

export const frontElements = (
  size: { width: number; height: number },
  colorMode: 'light' | 'dark'
) => [
  <FrontElement id='_0'>
    <TextWidth>
      <p>
        Ein Spass, der die Familie B. bis heute belastet. Körperlich wie auch
        psychisch, sagt Anita: «Ich sass mehrmals heulend in meinem Reha-Zimmer
        und hab mich gefragt: Wozu das alles? Warum habe ich überhaupt
        überlebt?» Sie kam jedoch immer wieder zum selben Schluss: «Ich muss
        kämpfen und so schnell wie möglich gesund werden – für meine Familie.»
      </p>
      <p>
        Ähnlich geht es Hunderten anderen Betroffenen in der Schweiz, die
        verantwortungslosen Lenkern zum Opfer fallen.
      </p>
    </TextWidth>
  </FrontElement>,
  <TextWidth
    id='_1'
    style={MapOverlayStyle}
    // distanceTop={200}
    distanceBottom={size.height / 2}
  >
    <p>
      Eine Auswertung dieser Zeitung von Daten des Bundes zeigt das Ausmass des
      Problems erstmals auf einen Blick. Dargestellt sind{' '}
      <b>alle Unfälle zwischen 2013 und 2021 mit verletzten Personen</b>, bei
      denen die gültige Höchst&shy;geschwindigkeit überschritten wurde.{' '}
      <b>983 kleine Punkte</b> finden sich auf der Karte. Hinter jedem von ihnen
      steckt eine andere Leidensgeschichte.
    </p>
    <Key
      swatchSize={22}
      style={{
        backgroundColor: 'var(--site-background)',
      }}
      entries={[
        {
          label: 'Unfälle mit',
          size: 22,
          entries: [
            {
              type: 'circle',
              label: 'maximal leicht verletzten Personen',
              color: '#FFE462',
            },
            {
              type: 'circle',
              label: 'schwer verletzten Personen',
              color: '#E78D38',
            },
          ],
        },
      ]}
    />
  </TextWidth>,
  <FrontElement id='_2' distanceBottom={0}>
    <TextWidth>
      <p>
        Raserunfälle erregen jeweils grosse öffentliche Aufmerksamkeit. Im Fokus
        stehen die Fahrer und ihre Sportwagen mit Hunderten Pferdestärken.
        Selten aber wird über die Opfer gesprochen. Unschuldige, die mitten aus
        dem Leben gerissen werden, sich danach jahrelang zurückkämpfen müssen.
      </p>
      <p>
        Hier erzählen sie, was sie durchgemacht haben. Und wie sie sich von der
        Politik, die derzeit an einer Lockerung der Raserstrafen herumwerkelt,
        im Stich gelassen fühlen.
      </p>
    </TextWidth>
    <Quote>«Sie schrie: ‹Mami, Mami!› Aber Anita war bewusstlos.»</Quote>
    <TextWidth>
      <p>
        Die Welt von Christian B. gerät an jenem Samstagabend im Oktober 2019
        aus den Fugen. Zwei Polizisten klingeln an der Tür. Fragen, ob sie
        reinkommen dürfen. «Da war klar, dass etwas nicht gut ist», sagt der
        Familienvater. Anita war mit Tochter Malea auf dem Heimweg von einem
        Kindergeburtstag. Es sei zu einem schweren Unfall gekommen, informieren
        ihn die Beamten. Man habe beide Opfer ins Spital gebracht, sie würden
        gerade notoperiert. «Mir hat es den Boden unter den Füssen weggezogen»,
        erinnert sich der 44-Jährige.
      </p>
      <p>
        Zuerst fährt Christian B. ins Zürcher Universitätsspital, wo seine Frau
        liegt. Noch bevor er sie sehen kann, erhält er eine Push-Nachricht:
        «Beide Opfer in Lebensgefahr», berichtet der Blick. «Irgendwann kam dann
        der Notfallarzt heraus mit dem Kittel voller Blut», erinnert sich der
        Marketingfachmann. «Er sagte, meine Frau habe grauenhaft viele
        Knochenbrüche. Was aber noch mehr Sorgen mache, sei die Hirnblutung.»
        Die Anklageschrift der Zürcher Staatsanwalt listet über zehn
        Verletzungen auf, darunter ein Schädel-Hirn-Trauma und Brüche vom
        Oberarm bis zum Fuss. Die Feuerwehr habe Anita B. mit hydraulischen
        Bergungsgeräten «aus dem total zerstörten Ford» herausschneiden müssen.
        Ihre Verletzungen seien «lebensgefährlich» gewesen – wie auch bei
        Tochter Malea.
      </p>
    </TextWidth>
    <Image
      src={require('../../Assets/IMG_4857.JPG')}
      caption='Das Auto von Familie B. nach der schweren Kollision.'
      source='Foto: zvg'
    />
    <TextWidth>
      <p>
        «Die Ersthelfer haben mir später erzählt, wie sie die Tür von Malea
        aufreissen mussten», sagt Christian B. Man habe die damals Vierjährige
        abgeschnallt und ganz behutsam auf den Boden gelegt. «Sie schrie: ‹Mami,
        Mami!› Aber Anita war bewusstlos.» Erst, als der Notarzt eintrifft,
        lässt die Vierjährige los, schläft ebenfalls ein. Mit dem Helikopter
        geht es ins Zürcher Kinderspital.
      </p>
      <p>
        Auf der Intensivstation bietet sich ihm ein Anblick, den Christian B.
        nie mehr vergessen kann, wie er sagt. «Ich habe ein Mädchen gesehen,
        ganz bleich, mit einem Korsett um den Hals, an Maschinen und Geräte
        angeschlossen. Da ist es mir schwindlig geworden, sie mussten mich
        stützen.» Anfangs kann niemand sagen, wie schwer die
        Halswirbelverletzungen des Kindes sind. «Ich dachte an den Worst Case,
        dass mein Mädchen nie mehr laufen wird. Das war die schlimmste Nacht in
        meinem Leben.»
      </p>
      <p>
        Die Verarbeitung fällt schwer. Christian B. fängt nach der Kollision an,
        Zeitungsartikel über Unfälle junger Temposünder in der Schweiz zu
        sammeln. Nach eineinhalb Jahren hat er bereits rund 100 Artikel
        beisammen. «Wir haben ein Junglenker-Raserproblem», sagt er heute. «Aber
        das sehen die Politiker in Bern nicht.»
      </p>
      <p>
        Der Bund führte 2013 das Programm «Via Sicura» ein. Unter anderem trat
        der neue Raser-Artikel in Kraft. Laut diesem kassiert ein Lenker
        mindestens ein Jahr Gefängnis, wenn er «durch vorsätzliche Verletzung
        elementarer Verkehrsregeln das hohe Risiko eines Unfalls mit
        Schwerverletzten oder Todesopfern eingeht». Zum Beispiel durch eine
        besonders krasse Missachtung der zulässigen Höchstgeschwindigkeit: In
        einer 30er-Zone gilt ein Fahrer mit einer Geschwindigkeit ab 70
        Kilometern pro Stunde als Raser, auf Autobahnen ohne Einschränkung ab
        200.
      </p>
      <p>
        Seit diese Regel in Kraft ist, sank die Zahl der Unfälle mit überhöhter
        Geschwindigkeit um 32 Prozent. Das schärfere Gesetz hat die Strassen
        also sicherer gemacht. Zu diesem Urteil kam auch das Bundesamt für
        Strassen in einem Bericht zu «Via Sicura».
      </p>
    </TextWidth>
    <TextWidth>
      <iframe
        title='Unfälle wegen Überhöhter Geschwindigkeit gehen zurück'
        id='datawrapper-chart-XLNK4'
        src='https://datawrapper.dwcdn.net/XLNK4/1/'
        scrolling='no'
        frameBorder='0'
        style={{ border: 'none' }}
        width='100%'
        height='500'
      ></iframe>
    </TextWidth>
    <TextWidth>
      <p>
        Trotzdem überdenkt die Politik nun die harten Strafen für Raser.
        National- und Ständerat sprachen sich dieses Jahr für eine Abschwächung
        des entsprechenden Artikels aus. Statt Gefängnisstrafen sollen neu auch
        Geldstrafen möglich sein. Zudem wollte das Parlament die Dauer des
        Führerscheinentzugs in gewissen Fällen auf ein Jahr halbieren. Über die
        genauen Details sind sich die Räte noch uneinig. Der Ständerat wird sich
        in der Herbstsession erneut beraten.
      </p>
      <p>
        Befürworter der Lockerung, hauptsächlich Bürgerliche mit Draht zur
        Autolobby, wollten ursprünglich mehr Spielraum für die Gerichte
        schaffen. «Nicht jeder, der zu schnell fährt, ist ein Raser», sagte
        Mitte-Nationalrat Matthias Bregy, Vorstandsmitglied der TCS-Sektion
        Wallis, während einer Debatte.
      </p>
    </TextWidth>
    <ReactVideo
      videoUrls={[
        require('../../Assets/videos/V3_Knecht_Burkhart.webm'),
        require('../../Assets/videos/V3_Knecht_Burkhart.mp4'),
      ]}
      placeholder={require('../../Assets/video_ratsdebatte.jpg')}
      caption='Aufnahmen aus den Ratsdebatten zeigen, wie die Politiker argumentierten.'
      source={'Video: Das Schweizer Parlament'}
    />
    <TextWidth>
      <p>
        FDP-Präsident Thierry Burkart, ehemaliger Vizepräsident des TCS, wollte
        «unnötige Härte» vermeiden. Und SVP-Ständerat Hansjörg Knecht gab an,
        dank der Lockerung könnten «Personen, die aus nachvollziehbaren Gründen
        gehandelt haben», verhältnismässiger bestraft werden. «Ich denke
        beispielsweise an jemanden, der ein krankes Familienmitglied ins Spital
        bringen muss und dabei die Höchstgeschwindigkeit ausserorts auf einer
        leeren Strasse stark überschreitet.»
      </p>
      <p>
        Die Signale, die Bundesbern aussendet, sind für die Unfallopfer und ihre
        Angehörigen nicht nachvollziehbar. «Man sagt immer, wir hätten in der
        Schweiz eines der härtesten Strassenverkehrsgesetze», sagt Christian B.
        «Doch wir Opfer merken davon nichts.»
      </p>
      <p>
        Die Betroffenen gingen in den Ratsdebatten fast unter. Obwohl ihr Leben
        zum Teil innert Sekunden zerstört wird.
      </p>
    </TextWidth>
  </FrontElement>,
  <FrontElement id='_3' distanceBottom={400}>
    <TextWidth>
      <p>
        Larissa Caviezel ist mit dem Roller unterwegs auf der Hauptstrasse
        zwischen Domat/Ems und Felsberg. Es ist noch dunkel am frühen Morgen
        jenes 18. Januars 2017. Die Sicht beträgt laut Staatsanwaltschaft
        Graubünden maximal 50 Meter. Da kommt der Köchin plötzlich ein Audi Q5
        direkt entgegen. Der Lenker hatte zwei Autos vor sich, setzte aber
        dennoch zum Überholmanöver an. Nun kollidiert er frontal mit dem
        Motorrad der 27-Jährigen. Sie wird über 40 Meter weggeschleudert.
        Larissa ist sofort tot.
      </p>
      <p>
        Der 39-Jährige, der die junge Frau auf dem Gewissen hat, war gemäss
        Behörden mit rund 115 Kilometern pro Stunde gefahren. Erlaubt gewesen
        wären nur 80.
      </p>
    </TextWidth>
  </FrontElement>,
  <TextWidth id='_4' style={MapOverlayStyle}>
    <p>
      Es ist kein Einzelfall. Viele Unfälle enden tödlich, weil Fahrer zu fest
      aufs Gas drücken, wie die Auswertung dieser Zeitung belegt:{' '}
      <b>
        Seit 2013 kam es schweizweit zu 66 Unfällen mit Todesfolge, bei denen
        die Höchstgeschwindigkeit laut Unfallprotokoll überschritten wurde.
      </b>{' '}
      {/* Sie sind auf der Karte mit roten Punkten markiert. */}
    </p>

    <Key
      swatchSize={22}
      style={{
        backgroundColor: 'var(--site-background)',
      }}
      entries={[
        {
          entries: [
            {
              type: 'circle',
              label: 'Unfälle mit Verstorbenen',
              color: '#D3343F',
            },
          ],
        },
      ]}
    />
  </TextWidth>,
  <FrontElement id='_5' distanceBottom={0}>
    <TextWidth>
      <p>
        «Den Schmerz, das eigene Kind zu verlieren, kann man sich nicht
        vorstellen», sagt Heinz Caviezel, der Vater der verstorbenen Larissa.
        «Kinder sind unsere Zukunft. Und so etwas zu erleben, das ist einfach
        tragisch.»
      </p>
      <p>
        In die Trauer des Bündners mischt sich je länger, je mehr auch Wut auf
        die Behörden. Laut Medienberichten musste der Beschuldigte sein Billett
        schon vor dem schweren Unfall von 2017 viermal abgeben und war an
        mehreren Verkehrsunfällen beteiligt. Bei einem davon verstarb eine
        Person. «Trotzdem hat er nie eine Strafe erhalten, welche diesen Namen
        auch verdient», findet Heinz Caviezel. Bedingte Sanktionen oder
        Geldstrafen würden notorische Verkehrssünder nicht abschrecken. «Die
        Öffentlichkeit sollte doch geschützt werden und nicht der Täter.»
      </p>
    </TextWidth>
    <Image
      caption={'Köchin Larissa verstarb noch am Unfallort.'}
      source={'Foto: zvg'}
      src={require('../../Assets/larissa.jpg')}
    />
    <TextWidth>
      <p>
        Für die Todesfahrt bei Felsberg verhängte das Regionalgericht Imboden
        zwar eine Gefängnisstrafe von sechs Jahren gegen den Lenker. Doch das
        Kantonsgericht Graubünden setzte dieses Urteil im Oktober 2021 deutlich
        herunter auf 34 Monate, wobei nur 17 Monate unbedingt ausgesprochen
        wurden.
      </p>
      <p>
        Heinz Caviezel spricht von einer «Schande». Er fühle sich nicht mehr wie
        in einem Rechtsstaat. «Die möglichen Strafen werden nicht ausgeschöpft.
        Und jetzt will die Politik sie sogar noch senken. Ist das wirklich das
        Signal, das unser Parlament an solche Menschen senden will?» Den
        Schmerz, den er erlebe, könne man als Aussenstehender nicht
        nachvollziehen. «Ich frage mich manchmal, ob die Politiker genauso
        entscheiden würden, wenn sie selber ein Kind verloren hätten.»
      </p>
    </TextWidth>
    <Image
      caption={'Eine «Schande» – der Unfallort bei Domat/Ems.'}
      source={'Foto: Kapo GR'}
      src={require('../../Assets/domatems.jpg')}
    />
    <TextWidth>
      <p>
        Angehörige und Betroffene ärgern sich über Politik und Behörden. Hinzu
        kommt aber auch eine Wut auf die Täter. Das Unverständnis und die Frage,
        die nach jedem Unfall bleibt: Warum?
      </p>
      <p>
        Diese Zeitung hat zwei Dutzend Anklagen studiert, Staatsanwaltschaften
        befragt, Gerichtsprozesse besucht. Um zu verstehen, was Raser antreibt.
      </p>
      <p>
        Sie selbst können das jeweils kaum erklären. Oder sie wollen nicht. «Ich
        kann es nicht sagen. Normalerweise würde ich das nicht machen. Ich weiss
        es nicht.» So die Antworten eines 20-Jährigen, der vor einigen Wochen
        von der Richterin gefragt wurde, warum er so schnell fuhr. Mit 116 km/h
        war er durch die Stadt Zürich gebrettert, samt zwei Kollegen im Wagen.
        An einer Stelle, an der es «durchaus mal Passanten hat», wie die
        Richterin mahnte. Sie sprach eine Gefängnisstrafe gegen den Raser aus,
        allerdings bedingt.
      </p>
      <p>
        Gleich lautete das Verdikt bei einem Lenker, der ebenfalls im Juli vor
        dem Zürcher Bezirksgericht stand. Er erfüllte den Rasertatbestand gleich
        während mehrerer Fahrten. Teils hatte der junge Mann dabei nur eine Hand
        am Lenkrad – weil er sich mit dem Mobiltelefon selbst filmte. Den
        Behörden ging er erst ins Netz, als er auf der Autobahn raste, ins
        Schleudern geriet, einen Motorradfahrer knapp verfehlte und in eine
        Leitplanke knallte.
      </p>
    </TextWidth>
    <ReactVideo
      videoUrls={[
        require('../../Assets/videos/V4_Raservideos.webm'),
        require('../../Assets/videos/V4_Raservideos.mp4'),
      ]}
      placeholder={require('../../Assets/video_raser.jpg')}
      caption='Diese Videos stellte ein mutmasslicher Raser auf Facebook, der sich demnächst vor Gericht verantworten muss.'
      source='Video: Facebook'
    />
    <TextWidth>
      <p>
        Laut Gericht schuf der Mann wiederholt eine sehr hohe Gefahr für einen
        Unfall mit Schwerverletzten oder Todesopfern. Ob er sein Verhalten
        erklären könne, wollte die Richterin am Prozess wissen. «Ich weiss es
        nicht», antwortete der Beschuldigte. «Ich habe mir nicht viel überlegt,
        als ich das gemacht habe.» Warum er sich auch noch gefilmt habe? Ob er
        damit angeben wollte? «Ich habe das für mich aufgenommen, nicht
        irgendwie weitergeleitet oder so.»
      </p>
      <p>
        Für Jürg Boll sind das Schutzbehauptungen. Der ehemalige Zürcher
        Staatsanwalt leitete 14 Jahre lang die erste «Rasergruppe» der Schweiz.
        Er hat über 100 Raser angeklagt und vor Gericht erlebt, kennt ihre
        Motive genau. «Der wichtigste Faktor ist Imponiergehabe», sagt Boll{' '}
        <Link href='289730781642' className={colorMode}>
          (lesen Sie hier das ganze Interview)
        </Link>
        . Aus welchem Grund sollte man sich sonst beim Rasen filmen?»
      </p>
      <p>
        Laut Boll werden die meisten Raserunfälle von jungen, unerfahrenen
        Lenkern begangen. Mit hochmotorisierten Autos von 400 Pferdestärken oder
        mehr.
      </p>
      <p style={{ marginBlockEnd: 0 }}>
        Die Oberstaatsanwaltschaft Zürich stellte im letzten Jahr eine Häufung
        schwerwiegender Raserdelikte fest. «Allein innerhalb einer Periode von
        20 Tagen kam es im Oktober 2021 zu fünf mutmasslichen Raserunfällen»,
        heisst es auf Anfrage. Zwölf Fahrzeuge wurden dabei beschädigt, fünf
        Personen verletzt, teils auch Unbeteiligte. Motorenleistungen von 400
        bis 600 PS und Beschleunigungswerte von unter vier Sekunden von 0 auf
        100 km/h sind laut der Behörde bei Raserunfällen schon fast der
        Normalfall. «Solche leistungsstarken Fahrzeuge sind heute als Leasing-­
        oder Mietfahrzeuge für fast jedermann erschwinglich.» Gerade in den
        Händen von ungeübten Junglenkern seien sie besonders gefährlich,
        «insbesondere dann, wenn noch die Sicherheitsassistenten manuell
        deaktiviert werden».
      </p>
    </TextWidth>
  </FrontElement>,
  <FrontElement
    id='_6'
    distanceTop={0}
    distanceBottom={size.height * 2}
    style={{ paddingTop: 0 }}
  >
    <TextWidth>
      <iframe
        title='Neulenker verursachen die meisten Tempo-Unfälle'
        id='datawrapper-chart-5egJL'
        src='https://datawrapper.dwcdn.net/5egJL/3/'
        scrolling='no'
        frameBorder='0'
        style={{ border: 'none' }}
        width='100%'
        height='500'
      ></iframe>
    </TextWidth>
    <TextWidth>
      <p>
        Auch der Unfallraser von Dietikon schraubte laut Zürcher
        Staatsanwaltschaft an den Fahrzeugeinstellungen herum. Der gelernte
        Automobilfachmann habe die Stabilitätskontrolle aus- und die
        «sportlich-dynamische Fahrweise» sowie den Heckantrieb eingeschaltet.
        Damit kann der 20-Jährige die Räder durchdrehen lassen und driften. Doch
        offenbar hat er den rund zwei Tonnen schweren BMW, den ein Kollege für
        24 Stunden gemietet hat, nicht im Griff. Und schiesst über die
        Sicherheitslinie, über drei Spuren – in das Auto von Anita B. mit
        Tochter Malea.
      </p>
      <p>
        Als die beiden im Wrack um ihr Leben kämpfen, wählt der
        Unfallverursacher laut Anklage zwar den Notruf, allerdings ohne eine
        korrekte Unfallmeldung, welche den genauen Unfallort beinhaltet, zu
        machen. Der Beschuldigte habe sich nicht pflichtgemäss um die Verletzten
        gekümmert. Sondern bei seinem BMW eine «Rauchpause» eingelegt, so die
        Staatsanwaltschaft.
      </p>
      <p>
        Im Juni musste sich der junge Mann vor dem Bezirksgericht Dietikon
        verantworten. Laut Gerichtsbericht des «Blicks» sagte er: «Ich
        entschuldige mich noch einmal bei den Opfern. Es tut mir enorm leid. Ich
        versuche, wiedergutzumachen, was in meiner Macht liegt.»
      </p>
    </TextWidth>
    <Quote>«Unschuldige Menschen haben Sie gefährdet und verletzt.»</Quote>
    <TextWidth>
      <p>
        Anita B. war am Prozess mit dabei, auch wenn es sie viel Kraft kostete.
        Ob die Entschuldigungen des Beschuldigten ernst gemeint waren, kann sie
        nicht sagen. Verstehen kann sie das Ganze bis heute nicht. «Wie kann man
        einen Wagen austesten, zu einer Uhrzeit, wo die Strasse so stark
        befahren ist? Dafür habe ich kein Verständnis.»
      </p>
      <p>
        Das Gericht verhängte am Ende eine unbedingte Freiheitsstrafe von 46
        Monaten. «Sie haben sich halsbrecherisch verhalten», so die Richterin.
        «Unschuldige Menschen haben Sie gefährdet und verletzt.»
      </p>
      <p>
        Die Verteidigung des Beschuldigten hat nun Berufung angemeldet gegen das
        Urteil. Für den Lenker gilt die Unschuldsvermutung. Seine Anwältin will
        sich auf Anfrage nicht äussern.
      </p>
      <p>
        Somit geht die Geschichte auch für Familie B. weiter. Fast drei Jahre
        sind seit dem Unfall vergangen. «Nun dauert es durch den Weiterzug wohl
        noch mal weitere eineinhalb Jahre bis zu einem nächsten Prozess», sagt
        Christian B.
      </p>
    </TextWidth>
    <ReactVideo
      videoUrls={[
        require('../../Assets/videos/V1_Christian_und_Anita_B.webm'),
        require('../../Assets/videos/V1_Christian_und_Anita_B.mp4'),
      ]}
      placeholder={require('../../Assets/video_familie.jpg')}
      caption='Anita und Christian B. sprechen im Video über gefährliche Junglenker und die Strafen in der Schweiz.'
      source='Video: Alexandra Aregger, Roland Gamp'
    />
    <TextWidth>
      <p>
        Genauso muss sich Heinz Caviezel gedulden. Der Todestag seiner Tochter
        Larissa, der Köchin aus Graubünden, liegt sogar schon fünfeinhalb Jahre
        zurück. Abgeschlossen ist aber auch dieser Fall nicht. Seit neun Monaten
        wartet der Vater auf ein schriftlich begründetes Urteil des
        Kantonsgerichts. Erst dann wird sich zeigen, ob die Staatsanwaltschaft
        den Entscheid akzeptiert oder vor die nächste Instanz weiterzieht. «Ich
        fühle mich machtlos und kann nur zuschauen», sagt Caviezel. Das
        langwierige Verfahren sei für die Familie eine Katastrophe. «Wir können
        so nicht abschliessen», sagt er. «Das ist schmerzhaft für uns.»
      </p>
      <p>
        Nach einem Raserunfall daure es häufig Jahre, bis ein Urteil vorliege,
        sagt der Luzerner Anwalt Christian Haag. Er vertritt viele Opfer von
        Verkehrs- und auch spezifisch Raserunfällen. «Ist eine gerichtliche
        Durchsetzung von Schadenersatzzahlungen nötig, kann dies teilweise über
        10 Jahre, im Extremfall gar bis zu 20 Jahre dauern.» Dies berge eine
        grosse Belastung für die Unfallopfer. «Hinzu kommt mitunter, dass die
        Staatsanwaltschaft Opfer zu wenig mit einbezieht», kritisiert der
        Fachanwalt. Es dauert gemäss Haag teils mehrere Monate, bis Unfallopfer
        überhaupt erfahren, was die Erstabklärungen der Polizei ergeben haben.
        «Diese grosse Ungewissheit für Unfallopfer erschwert die Verarbeitung
        zusätzlich.»
      </p>
      <p>
        Der ehemalige Strafverfolger Jürg Boll, der sich heute als Stiftungsrat
        von Roadcross für Verkehrsopfer einsetzt, begründet die Dauer mit der
        aufwendigen Unfallrekonstruktion. Je nach Situation gibt es ein
        Gutachten, die Verteidigung muss dazu Stellung nehmen, es gibt weitere
        Fragerunden und Einvernahmen. «Die Falllast der Staatsanwältinnen und
        Staatsanwälte hat natürlich auch Einfluss auf die Verfahrensdauer», so
        Boll. Die Arbeit nimmt stetig zu: Seit der Einführung des Raserartikels
        2013 gab es immer mehr Verurteilungen. Im letzten Jahr wurden
        schweizweit über 500 Täter abgestraft.
      </p>

      <iframe
        title='Rekord an Verurteilungen'
        id='datawrapper-chart-2OxBz'
        src='https://datawrapper.dwcdn.net/2OxBz/1/'
        scrolling='no'
        frameBorder='0'
        style={{ border: 'none' }}
        width='100%'
        height='429'
      ></iframe>
      <p>
        Nicht nur vor Gericht, auch zu Hause ist es für Familie B. ein langer
        Kampf. Die verunfallte Mutter und ihre Tochter liegen nach dem
        Unfall getrennt in verschiedenen Spitälern. Sie können sich sechs
        Wochen nicht sehen.
      </p>
      <p>
        Die Ärzte versorgen die vierjährige Malea zunächst eineinhalb Wochen auf
        der Intensivstation. Es folgen Wochen in der Reha: «Sie musste lernen,
        zu laufen, wieder lernen, zu reden», erzählt Christian B. Seine Tochter
        sei in ihrer Entwicklung um ein Jahr zurückgefallen. Ständig plagten
        Kopfschmerzen die 7-Jährige, sie habe motorische Schwierigkeiten. Und
        sie sei ängstlich geworden, sagt Mutter Anita: «Sie getraut sich
        beispielsweise noch nicht, Velo zu fahren, da sie Angst hat,
        herunterzufallen und danach wieder Probleme zu haben.»
      </p>
      <p>
        Meist schläft die heute 7-Jährige wieder bei den Eltern im Bett, was vor
        dem Unfall nie vorkam.
      </p>
    </TextWidth>
    <Image
      caption={'Hinter Familie B. liegt ein jahrelanger Kampf.'}
      source={'Foto: Silas Zindel'}
      src={require('../../Assets/familieb.jpg')}
    />
    <TextWidth>
      <p>
        Christian B., der sich nach dem Unfall intensiv um seine Familie kümmern
        muss, verliert seinen Job und kann über längere Zeit kein Geld
        verdienen. Seine Frau Anita wiederum kämpft sich drei Monate lang in
        einer Rehaklinik zu ihren alten Kräften zurück, doch diese wird sie nie
        wiedererlangen. Sie kehrt zunächst im Rollstuhl nach Hause zurück, geht
        danach an Krücken. Es vergehen Monate, bis sie alltägliche Aufgaben
        wieder allein meistern kann. Auch heute ist die Feinmotorik der linken
        Hand beeinträchtigt. Die zweifache Mutter, neben Malea hat sie einen
        elfjährigen Sohn, muss in die Physiotherapie und hat täglich Schmerzen
        im Fuss.
      </p>
      <p>
        «Dinge wie mit den Kindern Schlittschuhlaufen, in den Europapark gehen
        oder Schlitteln, das ist alles schwieriger als früher.» Es werde noch
        ein längerer Prozess für sie, sagt Anita. «Ich werde erst recht in
        ein Loch fallen, wenn ich realisiere, dass ich keine Fortschritte mehr
        mache. Dass es nicht besser wird und ich damit leben muss.»
      </p>
      <p>
        Finanziell, körperlich, psychsich: Die Opfer von Verkehrsunfällen leiden
        auf mehrere Arten. Wohl deshalb macht es sie so wütend, dass die Täter
        nun sanfter angefasst werden sollen.
      </p>
      <p>
        Wenn sie aus dem Traum erwacht, in dem die Bilder des Unfalls hoch
        kommen, dann ist Anita B. aber auch froh. Dankbar, noch am Leben zu
        sein. Andere Opfer hätten weniger Glück, sagt sie. «Und dann stirbt
        jemand – wegen ein bisschen Spass.»
      </p>
    </TextWidth>
  </FrontElement>,
]
